import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../../../../Common';

import './index.scss';

const MutateTipPionTitle = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <Input
      {...props}
      {...field}
      className={classNames(
        'mutate-tip-pion-title',
        { 'mutate-tip-pion-title-error': fieldMeta.error },
        props.className,
      )}
      type="text"
      placeholder="Title"
    />
  );
};

export default MutateTipPionTitle;
